<!-- 海报编辑页 -->
<template>
  <div @click="handleClickCanvas" @keyup.esc="handleKeyup" ref="editorPane">
    <!-- <div class="editor-title">点击图片或文字部分进行编辑</div> -->
    <div class="top-view">
      <div class="top-title">点击图片或文字部分进行编辑</div>
      <div class="my-poster-btn" @click="screenshots">{{$store.state.user.from == 'miniApp' ? '生成海报' : '保存并分享' }}</div>
    </div>
    <div v-if="projectData != null" class="editor-main" ref="canvaspanel" id="canvas-panel" :style="{ width: projectData.width + 'px', height: projectData.height + 'px'}">
        <div class="page-preview-wrapper" :style="getCommonStyle(activePage.commonStyle)">
          <edit-shape
                v-for="item in activePage.elements"
                :key="item.uuid"
                :uuid="item.uuid"
                :edit="item.edit"
                :defaultStyle="item.commonStyle"
                :style="getCommonStyle({width: item.commonStyle.width, height: item.commonStyle.height, left: item.commonStyle.left,top: item.commonStyle.top,position: item.commonStyle.position})"
                @handleElementClick="handleElementClick(item)"
                @resize="handleElementResize"
                @afterClick="afterClick(item)"
                :active="item.uuid === activeElementUUID"
                >
            <component :style="getCommonStyle({...item.commonStyle, top: 0, left: 0})" :is="item.elName" class="element-on-edit-pane" :class="{'modelbg': item.modelbg}" v-bind="item.propsValue['imageSrc'] == '--logoImage--' ? {imageSrc: logoImg} : item.propsValue" :fit="item.hasOwnProperty('fit') ? item.fit : ''"/>
            <!-- <component :style="getCommonStyle({...item.commonStyle, top: 0, left: 0})" :is="item.elName" class="element-on-edit-pane"/> -->
          </edit-shape>
        </div>
    </div>
    <postershare ref="postershare" :title="title" :canvasImg="canvasImg" :posterId="posterId"></postershare>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import {_qk_register_components_object} from '@/plugins/index'
import html2canvas from 'html2canvas'
import editShape from '@/components/edit-shape'
import postershare from './posterShare.vue'
import utils from '../../utils/util'
import {mapState, mapGetters} from 'vuex'
// import VConsole from 'vconsole';


export default {
  props: {
    // canvas画板缩放
    scale: {
      type: Number,
      // default: 0.95
      default: 1
    }
  },
  // import引入的组件需要注入到对象中才能使用
  components: {
    postershare,
    // 批量注册qk组件
    ..._qk_register_components_object,
    // 画板组件
    [editShape.name]: editShape
  },
  data () {
    // 这里存放数据
    return {
      show: false,
      currentUUID: '',
      getCommonStyle: utils.getCommonStyle,
      editorPaneWidth: 0,
      activePage: {},
//       activePage: 
// {
//   "uuid":"8f1900ad-ce81-4ec9-8bd8-76749c6ba8a1",
//   "name":"",
//   "height":723,
//   "elements":[
//       {
//           "uuid":"637e8b8b-c83c-4fa8-9d99-e5da07deb40b",
//           "elName":"qk-image",
//           "animations":[

//           ],
//           "commonStyle":{
//               "position":"absolute",
//               "width":70,
//               "height":70,
//               "top":594,
//               "left":152.5,
//               "rotate":0,
//               "paddingTop":0,
//               "paddingLeft":0,
//               "paddingRight":0,
//               "paddingBottom":0,
//               "marginTop":0,
//               "marginLeft":0,
//               "marginRight":0,
//               "marginBottom":0,
//               "borderWidth":0,
//               "borderColor":"",
//               "borderStyle":"solid",
//               "borderRadius":0,
//               "boxShadow":"",
//               "fontSize":16,
//               "fontWeight":500,
//               "lineHeight":1.4,
//               "letterSpacing":0,
//               "textAlign":"center",
//               "color":"#000000",
//               "backgroundColor":"",
//               "backgroundImage":"",
//               "backgroundSize":"cover",
//               "opacity":1,
//               "zIndex":7
//           },
//           "events":[

//           ],
//           "propsValue":{
//               "imageSrc":"--wxqrcode--"
//           },
//           "valueType":"String"
//       },
//       {
//           "uuid":"b515ea8a-7a34-4b6c-8d47-d5c26ab4dbec",
//           "elName":"qk-image",
//           "animations":[

//           ],
//           "commonStyle":{
//               "position":"absolute",
//               "width":375,
//               "height":723,
//               "top":0,
//               "left":0,
//               "rotate":0,
//               "paddingTop":0,
//               "paddingLeft":0,
//               "paddingRight":0,
//               "paddingBottom":0,
//               "marginTop":0,
//               "marginLeft":0,
//               "marginRight":0,
//               "marginBottom":0,
//               "borderWidth":0,
//               "borderColor":"",
//               "borderStyle":"solid",
//               "borderRadius":0,
//               "boxShadow":"",
//               "fontSize":16,
//               "fontWeight":500,
//               "lineHeight":1.4,
//               "letterSpacing":0,
//               "textAlign":"center",
//               "color":"#000000",
//               "backgroundColor":"",
//               "backgroundImage":"",
//               "backgroundSize":"cover",
//               "opacity":1,
//               "zIndex":4
//           },
//           "events":[

//           ],
//           "propsValue":{
//               "imageSrc":"https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/poster/exhibition.jpg"},
//               "valueType":"String"
//       }
//   ],
//   "commonStyle":{
//       "backgroundColor":"",
//       "backgroundImage":"",
//       "backgroundSize":"cover"
//   }
// },
      title: '',
      canvasImg: '',
      posterId: 0,
      logoImg: '',
      wxqrcode: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
      // projectData: state => state.editor.projectData,
      activeElementUUID: state => state.editor.activeElementUUID
    }),
    ...mapGetters([
      'projectData',
      'currentPageIndex',
      'activeElementIndex',
      'activeElement',
      'getTemplate'
    ]),
    getMenuOptionsPositionStyle(){
      let both = (this.editorPaneWidth - this.projectData.width * this.scale) / 2;
      let right = both < 60 ? 16 : both;
      return {
        right: right + 'px'
      }
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /**
     * 保存
     */
    save() {
      window.I.$RangersEvent('posterEditPage_saveBtn_click')
      var template = JSON.parse(this.getTemplate);
      // if (!template.contentId) {
      //   this.$Toast('请选择展品');
      //   return;
      // }
      // this.screenshots();
      var contentType = template.type;
      var contentId = template.contentId
      var templateId = template.id;
      var name = template.name ? template.name : template.title;
      this.title = name;
      var params = {
        exhibitionId: this.$store.state.user.exhibitionId,
        templateId: templateId,
        name: name,
        title: template.title,
        content: JSON.stringify(this.activePage).replace('--logoImage--', this.logoImg),
        contentType: contentType,
        contentId: contentId,
        appId: this.$store.state.user.appId,
        img: this.canvasImg
      }
      this.$http.addPoster(params).then(res => {
        var data = res.data;
        this.posterId = data;
        if (this.$store.state.user.from == 'miniApp') {
          wx.miniProgram.navigateTo({
            url: '/pages/iztShare/saveImg?src=' + this.canvasImg
          })
          return;
        }
        this.$Toast.success();
        this.$refs.postershare.setShow(true, this.posterId);
      }).catch(error => {
        this.$Toast(error.data.message);
        // Dialog({ message: error.data.message });
      })
    },
    afterClick(item) {
      if (item.edit && item.elName == "qk-text") {
        // 可编辑-label
        console.log('可编辑');
        this.$router.push({
          name: 'editText',
          params: {
            uuid: this.currentUUID
          }
        })
      }
      if (item.edit && item.elName == "qk-image") {
        // 可编辑-image
        this.$router.push({
          name: 'goodsList',
          params: {
            uuid: this.currentUUID
          }
        })
      }
    },
    /**
     * 元素被点击
     * @param uuid
     */
    handleElementClick(item) {
      this.currentUUID = item.uuid;
      this.$store.dispatch('setActiveElementUUID', item.uuid);
    },
    /**
     * 移动改变元素大小定位
     * @param pos 当pos有值表示移动中需要实时同步样式变化，pos为undefind时则表示移动结束，记一次历史纪录
     * 鼠标移动完成时才记入历史纪录
     */
    handleElementResize(pos) {
      if (!pos) {
        this.$store.dispatch('addHistoryCache')
        return;
      }
      console.log(this.activeElementIndex);
      var index = this.getElementIndex();
      console.log(index);
      this.activePage.elements[index].commonStyle.left = pos.left
      // 更新元素commonStyle
      this.activePage.elements[index].commonStyle = {
        ...pos
      }
    },
    getElementIndex() {
      console.log('currentUUID:');
      console.log(this.currentUUID);
      var index = this.activePage.elements.findIndex(v => {
        return v.uuid === this.currentUUID;
      });
      return index;
    },
    handleClickCanvas(e) {
      if (!e.target.classList.contains('element-on-edit-pane') && !e.target.classList.contains('menu-item-on-edit-panel')) {
        this.$store.dispatch('setActiveElementUUID', '');
      }
    },
    /**
     * 对元素进行操作命令
     */
    handleElementCommand(command) {
      this.$store.dispatch('elementCommand', command)
    },
    /**
     * 监听键盘事件
     * @param e
     */
    handleKeyup(e) {
      console.log(1111, e);
    },
    /**
     * 提供截屏作为项目主图
     */
    screenshots() {
      // alert('screenshots');
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      this.$Toast.loading({
        message: '',
        forbidClick: true,
      });
      // const el = document.querySelector('#canvas-panel')
      const el = this.$refs.canvaspanel
      const height = (this.activePage.height | 535) * (window.screen.width / 375) * this.scale
      const hc = window.html2canvas || html2canvas

      // new VConsole();
      hc(el, {
        // width:375,
        height: height ,
        useCORS:true,
        logging:true,
        // y: 60,
        scrollY: 0,
        scrollX: 0,
        imageTimeout: 30000,
        fit: 'cover',
        // 设置跨域接口
        // proxy: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/'
        // https://ef-base-rules.oss-cn-beijing.aliyuncs.com/null/91620356__1623203364997.png
        // proxy: 'https://stat.eastfair.com'
      }).then(canvas => {
        // this.activePage.height = 605
        let url= canvas.toDataURL("image/png");
        const base64 = url.split('base64,')[1]
        this.upLoadImg(base64, 'POSTER');
        
      }).catch(error => {
        console.log(error)
        // alert('error');
        // alert(error);
      });
    },
    /**
     * type: POSTER（生成海报图片）、WXCODE（微信二维码）
     */
    upLoadImg(base64, type) {
      var theme = this.$route.query.theme ? this.$route.query.theme+'/' : 'huanbao/'
      var objName = theme + this.$tools.uuid() + '.png'; // jpg
      var params = {
        bizType: 'IMAGEFILE',
        bucketName: 'ef-imaster-file',
        objectName: objName,
        baseStr: base64
      }
      this.$Toast.loading({
        message: '请稍后...',
        forbidClick: true,
      });
      this.$http.uploadImageByBaseStr(params).then(res => {
        var data = res.data;
        if (type == 'POSTER') {
          // 生成海报图片
          this.canvasImg = data;
          // 上传完图片后调用保存接口
          this.save();
        }
        if (type == 'WXCODE') {
          // 生成微信二维码
          this.wxqrcode = data;
          var jsonStr = JSON.stringify(this.activePage).replace('--wxqrcode--', this.wxqrcode);
          this.activePage = JSON.parse(jsonStr);
        }
      }).catch(error => {
        console.log(error)
        if (type == 'POSTER') {
          this.$Toast('图片保存失败'); 
        }
        if (type == 'WXCODE') {
          this.$Toast('二维码生成失败'); 
        }
      })
    },
    getExhibitorInfo() {
      var params = {
        exhibitionId: this.$store.state.user.exhibitionId,
        id: this.$store.state.user.exhibitorId,
      }
      this.$http.getExhibitorBaseInfo(params).then(res => {
        var data = res.data;
        // debugger
        
        this.logoImg = data.logoImage;
        var exhibitionBoothNumber = data.exhibitionBoothNumber || '暂无';

        var name = data.name;
        var images = data.advertsImage ? data.advertsImage.split(',') : [];
        var advertsImage = ''
        
        if (images.length != 0) {
          advertsImage = images[0]
        }

        // 去掉展商模板 公司名称：
        var jsonStr = JSON.stringify(this.activePage).replace('--logoImage--', this.logoImg).replace('--displayNumber--', exhibitionBoothNumber).replace('--companyName--', name).replace('公司名称：', '').replace('--advertsImage--', advertsImage);
        
        this.activePage = JSON.parse(jsonStr);

        var template = JSON.parse(this.getTemplate);
        if (template.type == 'ACTOR') {
          template.contentId = data.id;
          this.$store.commit('setTemplate', JSON.stringify(template))
        }
        if (this.$store.state.user.from == 'miniApp') {
          this.saveParams();
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getWxQRCode(scene) {
      var path = "";
      var template = JSON.parse(this.getTemplate);
      if (template.type == 'ACTOR') {
        // 展商海报
        path = "pages/exhibitorDetail/index"
      }
      if (template.type == 'PRODUCT') {
        // 展品海报
        path = "pages/details/exhibit-detail"
      }
      if (template.type == 'EXHIBITION') {
        // 展会海报
        path = "pages/index"
      }
      var params = {
        applicationId: this.$store.state.user.appId,
        appType: 'visitor',
        page: path,
        scene: scene,
        width: '128'
      }
      this.$http.getACodeUnLimit(params).then(res => {
        this.wxqrcode = 'data:image/png;base64,' + res.data;
        this.upLoadImg(res.data, 'WXCODE');
      }).catch(error => {

      })
    },
    /** 获取二维码ID */
    saveParams() {
      var useraccountId = this.$store.state.user.useraccount_id
      var params = {
        useraccountId: useraccountId
      };
      var template = JSON.parse(this.getTemplate);
      if (template.type == 'ACTOR') {
        // 展商海报
        // 0aa5527e574f424f9f859d20b7a3f25a
        // params = {
        //   id: '0aa5527e574f424f9f859d20b7a3f25a',
        //   templateId: template.id
        // }
        var template = JSON.parse(this.getTemplate);
        params = {
          useraccountId: useraccountId,
          // id: this.$store.state.user.exhibitionId,
          id: template.contentId,
          templateId: template.id
        }
      }
      if (template.type == 'PRODUCT') {
        // 展品海报
        // c11fab6e45ab43f6a09d7ecea788f0c5
        params = {
          useraccountId: useraccountId,
          id: template.contentId,
          templateId: template.id
        }
        // params = {
        //   id: 'c11fab6e45ab43f6a09d7ecea788f0c5',
        //   templateId: template.id
        // }
      }
      this.$http.saveParam({param: JSON.stringify(params)}).then(res => {
        console.log(res);
        this.getWxQRCode(res.data);
      })
    },
    getImage(url) {
      const _this = this
      var xhr = new XMLHttpRequest();
      xhr.open('get', url, true);
      // 设置请求头（这一步得设置不然oss图片还是跨域）
      xhr.setRequestHeader("Cache-Control", "no-cache")
      xhr.responseType = 'blob';
      
      xhr.onload = function () {
        if (this.status === 200) {
          const imageSrc = URL.createObjectURL(this.response);
          if (_this.activePage) {
            _this.activePage.elements.map(item => {
              if (item.uuid === "b515ea8a-7a34-4b6c-8d47-d5c26ab4dbec") {
                item.propsValue.imageSrc =  imageSrc
              }
              return item
            })
          }
        }
      };
      xhr.send();
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    window.I.$RangersEvent('posterEditPage_view');
    // if (!this.getTemplate.type == 'PRODUCT') {
      // 展商
      // 不展示边框点点 active
      // this.$store.dispatch('setActiveElementUUID', '');

      this.getExhibitorInfo();
    // }
    console.log(this.projectData);
    // if (this.projectData.hasOwnProperty('elements')) {
    if (this.projectData) {
      // 程序中有数据
      this.activePage = this.projectData;
      return;
    }
    // 程序中无数据
    // 保存模版数据
    this.$store.commit('setTemplate', this.$route.query.item)
    var item = JSON.parse(this.$route.query.item);
    this.activePage = JSON.parse(item.template);

    
    if (this.activePage) {
      const type = item.type
      // "展会模板"
      if (type === "EXHIBITION") {
        this.getImage("https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/poster/exhibition.jpg")
      }
      // 展品模板 展商模板 
      if (type === "PRODUCT" || type === "ACTOR") {
        this.getImage("https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/huanbao/huanbao-poster-bg-1.png")
      }
    }
    this.$store.commit('setPrjectData', this.activePage)
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.editor-pane {
  height: 100vh;
  width: 100%;
  border: 1px solid #f5f5f5;
  border-width: 0 1px;
  background-image: linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0), linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0);
  background-position: 0 0, 13px 13px;
  background-size: 26px 26px;
  display: flex;
  justify-content: center;
}
.element-on-edit-pane {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.editor-pane-inner {
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 20px;
}

.editor-main {
  height: 633px;
  position: relative;
  /* background: white; */
  transform-origin: center top;
  /* margin-left: 15px;
  margin-right: 15px; */
  /* transform: scale(0.8); */
}
.page-preview-wrapper {
  height: 100%;
  position: relative;
}
.editor-title {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
  margin-top: 11px;
  margin-bottom: 25.5px;
}
.editor-save-view {
  padding: 0px 30px 30px 30px;
  margin-top: 60px;

}
.editor-save {  
  text-align: center;
  background: var(--bgcolor);
  border-radius: 22px;
  height: 44px;  
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 44px;
}
.top-view {
  background: #F1F8FF;
  padding: 15px 15px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.top-title {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4B95FF;
  flex: 1;
}
.my-poster-btn {
  padding: 0px 12px;
  height: 31px;
  line-height: 31px;
  background:var(--bgcolor);
  text-align: center;
  border-radius: 15.5px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
}
</style>